export default "__VITE_ASSET__BSaVEmBY__"